import { logout } from '@/redux/slices/user.slice';
import { fetchResources } from '@/redux/thunks/resources.thunk';
import { createSlice } from '@reduxjs/toolkit';

interface ResourcesState { 
  data: {
    playlists: any[];
    podcasts: any[];
    secure: {
      audios: any[];
      images: any[];
    }
  };
  loading: boolean;
  success: boolean;
  error: any | boolean;
}

const initialState: ResourcesState = {
    data: {
      playlists: [],
      podcasts: [],
      secure: {
        audios: [],
        images: [],
      }
    },
    loading: false,
    success: true,
    error: false,
};

const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  reducers: {
    clearResources: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResources.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = false;
      })
      .addCase(fetchResources.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchResources.rejected, (state, action) => {
        state.loading = false
        state.success = false;
        state.error = action.error
      });
      builder.addCase(logout, (state) => {
        return initialState;
      })
  },
});

export const { clearResources } = resourcesSlice.actions;
export default resourcesSlice.reducer;
